module.exports = __webpack_public_path__ + "media/images/basic_logos/edit-23789efabf9050e09b3ea7f4f94edbc5.svg";